import { SectionHeading } from './SectionHeading'
import { Avatar } from './Avatar'

export const Bio = () => {
  return (
    <section id="profile" className="py-12 border-t border-ink-100">
      <SectionHeading number="01" title="プロフィール" />
      <div className="space-y-8">
        <div className="flex flex-col items-center gap-6 text-center sm:flex-row sm:items-center sm:gap-8 sm:text-left">
          <Avatar src="/avatar.webp" alt="西野 颯真" />
          <div>
            <h3 className="font-serif text-2xl font-bold leading-tight text-ink-800">
              西野 颯真
            </h3>
            <p className="mt-1 font-mono text-xs tracking-wider text-ink-600">
              Soma Nishino
            </p>
            <p className="mt-3 text-sm text-ink-600">2000年生まれ / 福岡</p>
          </div>
        </div>
        <div className="space-y-6 text-base leading-[1.95] text-ink-800">
          <p>
            合同会社FrectasでCTOを務め、クライアント向けのWebシステムやAIを活用した業務改善ツールを開発しています。要件定義から設計・実装・インフラ構築・運用まで、一貫して担当しています。
          </p>
          <p>
            学生時代から個人開発とアプリコンテストに取り組み、九州工業大学在学中に学生プロジェクト「Comet」を立ち上げました。
            Cometの活動が評価され、大学より特別賞を受賞しました。
            また、個人での開発・コンテストでの成果に対して技術賞も受賞しました。
            防災アプリ「MAPCHAIN」では、Yahoo! JAPAN主催「Digital Hack Day
            2021」の特別賞を受賞しました。
          </p>
          <p>
            2022年に個人開発した画像生成LINE
            Bot「お絵描きばりぐっどくん」は、友達登録240万人を超える規模まで運用しました。
            Stable
            Diffusionを誰もが使えるチャットUIに落とし込み、翻訳キャッシュなどにより運用コストを約10分の1に削減しました。
          </p>
          <p>
            現在はTypeScriptを中心に、Next.jsやHonoでフロントエンドからAPIまでを実装し、GCPとTerraformでインフラも構築しています。
            少人数でも早く検証・改善できるよう、AIを取り入れた開発体制づくりにも取り組んでいます。
          </p>
        </div>
      </div>
    </section>
  )
}
